import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */

/* @jsx mdx */

import DefaultLayout from "/home/runner/work/documentation/documentation/node_modules/gatsby-theme-doctornpm/src/components/layout.js";
export const _frontmatter = {};

const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};

const Screenshot = makeShortcode("Screenshot");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <p>{`You can export and review the metadata that npm stores about your personal account. The export is an archive containing the following information.`}</p>
    <ol>
      <li parentName="ol">{`Your personal details such as username, email address, full name, linked Twitter / GitHub accounts, masked Personal Access Tokens (PAT) and the organisations that you are a member of.`}</li>
      <li parentName="ol">{`Metadata of all the packages that you have access to.`}</li>
      <li parentName="ol">{`Each individual version of packages that you have published to npm.`}</li>
    </ol>
    <h2>{`How to request an export`}</h2>
    <ol>
      <li parentName="ol">{`Navigate to `}<a parentName="li" {...{
          "href": "https://www.npmjs.com/support"
        }}>{`npm support form`}</a></li>
      <li parentName="ol">{`Select "Account and Billing issues" category`}</li>
      <li parentName="ol">{`Select "Data export request" sub-category`}</li>
    </ol>
    <Screenshot src="/getting-started/managing-your-npm-user-account/requesting-your-data.png" alt="Screenshot showing the option to select a DSR export request from the support form." mdxType="Screenshot" />
    <ol {...{
      "start": 4
    }}>
      <li parentName="ol">{`Fill in the details and submit the form`}</li>
    </ol>
    <h2>{`Retrieving the exported data`}</h2>
    <p>{`After a request is placed our support team will review it and initiate an export on your behalf. Once the export process is complete you will receive an email with a link to an archive of your personal data. You must be authenticated to npmjs.com to download this archive.`}</p>
    <p>{`The download link will be available for 7 days, after which the exported data and the link is purged.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      